/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_To_ConnectInputs */



/**
* | output |
* | --- |
* | "Publish work to Connect" |
*
* @param {Publish_To_ConnectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const publish_to_connect = /** @type {((inputs?: Publish_To_ConnectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_To_ConnectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publier sur Connect")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veröffentlichen Sie Ihre Arbeit auf Connect")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblica il lavoro su Connect")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Опубликуйте свою работу в Connect.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicar trabajo en Connect")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将作品发布到 Connect")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Connectに作品を公開する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कनेक्ट पर काम प्रकाशित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publique seu trabalho no Connect")
	return /** @type {LocalizedString} */ ("Publish work to Connect")
});